import { Toast } from 'design-system/src/components/Toast/Toast';
import { Typography } from 'design-system/src/components/Typography/Typography';
import { toast } from 'react-hot-toast';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import ExtendedNewTaskForm from '../../components/tasks/ExtendedNewTaskForm';
const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-top: 24px;
  margin-bottom: 24px;
`;

export default function NewTaskPage() {
  const navigate = useNavigate();
  return (
    <Container>
      <Typography styledAs="h6" renderedAs="h1">
        Create a new task
      </Typography>
      <ExtendedNewTaskForm
        onSubmit={(taskId: string) => {
          toast.custom(() => <Toast variant="success">Task created.</Toast>);
          navigate(`/tasks/${taskId}`);
        }}
      />
    </Container>
  );
}
